export default {
    baseStyle: {
        linkBannerBlock: {
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '100%',
            py: 16,
            px: 8,
            position: 'relative'
        },
        linkBannerOverly: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'inherit',
            filter: 'brightness(40%)'
        },
        linkTestBlock: {
            position: 'relative',
            zIndex: '1'
        },
        linkBannerHeading: {
            fontSize: 'fontSize28',
            lineHeigt: '8',
            fontWeight: 'extrabold',
            textAlign: 'center'
        },
        linkBannerLinkBlock: {
            gap: '10px',
            flexWrap: 'wrap',
            justifyContent: 'center'
        },
        linkBannerLink: {
            fontSize: 'md',
            lineHeigt: '5',
            textDecoration: 'underline'
        }
    },
    parts: ['containerStyles']
}
